export const getPrimeUrl = (path: `/${string}`) => {
  return `${process.env.NEXT_PUBLIC_GOI_PRIME_URL}${path}`;
};
